import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['counts']

  connect() {
    this.beforeStreamRender = this.beforeStreamRender.bind(this)
    this.keepModal = this.keepModal.bind(this)
    this.forget = this.forget.bind(this)

    document.addEventListener('turbo:before-stream-render', this.beforeStreamRender)
    document.addEventListener('turbo:before-morph-element', this.keepModal)
    document.addEventListener('turbo:morph', this.forget)
    document.addEventListener('turbo:submit-start', this.forget)
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.beforeStreamRender)
    document.removeEventListener('turbo:before-morph-element', this.keepModal)
    document.removeEventListener('turbo:morph', this.forget)
    document.removeEventListener('turbo:submit-start', this.forget)
  }

  beforeStreamRender(event) {
    const stream = event.target

    if (stream.getAttribute('action') === 'refresh') this.refreshing = true
    if (stream.getAttribute('action') === 'refresh_row') event.detail.render = () => this.refreshRow(stream.getAttribute('target'))
  }

  async refreshRow(id) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return

    const response = await fetch(window.location.href, { headers: { Accept: 'text/html' } })
    const page = new DOMParser().parseFromString(await response.text(), 'text/html')

    const [row, ...copies] = document.querySelectorAll(`#${id}`)
    const fresh = page.getElementById(id)
    copies.forEach((copy) => copy.remove())

    if (row) {
      fresh ? row.replaceWith(fresh) : row.remove()
    } else if (fresh) {
      this.insert(fresh, page)
    }

    const counts = this.hasCountsTarget && page.getElementById(this.countsTarget.id)
    if (counts) this.countsTarget.replaceWith(counts)
  }

  insert(fresh, page) {
    const body = this.element.querySelector('tbody')
    const neighbour = fresh.previousElementSibling && document.getElementById(fresh.previousElementSibling.id)

    if (!body.querySelector('tr[id]')) {
      body.replaceWith(page.querySelector(`#${this.element.id} tbody`))
    } else if (neighbour) {
      neighbour.after(fresh)
    } else {
      body.prepend(fresh)
    }
  }

  keepModal(event) {
    if (this.refreshing && event.target.id === 'modal' && event.target.childElementCount > 0) event.preventDefault()
  }

  forget() {
    this.refreshing = false
  }
}
